import {takeEvery} from 'redux-saga/effects'

import {
  ADD_CLASSROOM,
  ADD_DAILY_SCHEDULE,
  ADD_EXTRACLASS,
  ADD_YEARLY_SCHEDULE,
  DELETE_DAILY_SCHEDULE,
  DELETE_DAILY_SCHEDULE_CLASSES,
  DELETE_MANY_DAILY_SCHEDULE,
  DELETE_MANY_YEARLY_SCHEDULE,
  DELETE_YEARLY_SCHEDULE,
  GET_CLASSROOM_BY_ID,
  GET_SCHEDULE_CLASS_LIST,
  GET_SCHEDULE_DAILY_BY_ID,
  GET_SCHEDULE_DAILY_CALENDAR,
  GET_SCHEDULE_DAILY_LIST,
  GET_SCHEDULE_YEARLY_BY_ID,
  GET_SCHEDULE_YEARLY_CALENDAR,
  GET_SCHEDULE_YEARLY_LIST,
  UPDATE_CLASSROOM,
  UPDATE_DAILY_SCHEDULE,
  UPDATE_YEARLY_SCHEDULE,
} from '../../../Actions/School/Schedule/ActionTypes/ApiActionTypes'
import fetchData from '../../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_SCHEDULE_YEARLY_LIST, fetchData)
  yield takeEvery(GET_SCHEDULE_DAILY_CALENDAR, fetchData)
  yield takeEvery(GET_SCHEDULE_YEARLY_CALENDAR, fetchData)
  yield takeEvery(DELETE_YEARLY_SCHEDULE, fetchData)
  yield takeEvery(DELETE_MANY_YEARLY_SCHEDULE, fetchData)
  yield takeEvery(GET_SCHEDULE_YEARLY_BY_ID, fetchData)
  yield takeEvery(UPDATE_YEARLY_SCHEDULE, fetchData)
  yield takeEvery(UPDATE_DAILY_SCHEDULE, fetchData)
  yield takeEvery(GET_SCHEDULE_DAILY_LIST, fetchData)
  yield takeEvery(DELETE_DAILY_SCHEDULE, fetchData)
  yield takeEvery(DELETE_MANY_DAILY_SCHEDULE, fetchData)
  yield takeEvery(GET_SCHEDULE_DAILY_BY_ID, fetchData)
  yield takeEvery(ADD_YEARLY_SCHEDULE, fetchData)
  yield takeEvery(GET_SCHEDULE_CLASS_LIST, fetchData)
  yield takeEvery(DELETE_DAILY_SCHEDULE_CLASSES, fetchData)
  yield takeEvery(ADD_CLASSROOM, fetchData)
  yield takeEvery(UPDATE_CLASSROOM, fetchData)
  yield takeEvery(GET_CLASSROOM_BY_ID, fetchData)
  yield takeEvery(ADD_DAILY_SCHEDULE, fetchData)
  yield takeEvery(ADD_EXTRACLASS, fetchData)
}

export default dataSaga
